import React from "react";
import { Link } from "react-router-dom";
import Bg from "../../images/shapes/shape_net_ico_hero_section_bg.svg";
import icon1 from "../../images/services/coin-bg.png";
import captainTcCard from "../../images/captain-tc-card.jpeg";

const Hero = () => {
  return (
    <section
      className="ico_hero_section section_decoration text-center"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <img loading="lazy" src={icon1} alt="ICO Site Logo" />

        <div className="row justify-content-center pb-2">
          <div className="col-lg-10">
            <h1
              className="hero_title mb-2 nxt_generation"
              data-aos="fade-up"
              data-aos-duration="800"
              style={{ fontSize: "50px" }}
            >
              Welcome to TopCoin UK!
            </h1>
            <h2 className="mb-3">NEW GENERATION TOPCOIN REWARDS</h2>
            <h4 className="" data-aos="fade-up" data-aos-duration="800">
              "Get Free TopCoin Every Time You Shop"
            </h4>

            <p className="mb-0">
              TopCoin UK is the UK's smart rewards and loyalty system. When you
              shop at participating businesses, you receive free TopCoin as part
              of our customer rewards programme. Customers from anywhere can
              collect TopCoin, access their wallets, and view available reward
              balances through TopCoin UK's loyalty system — with no hidden fees
              or sign-up charges.
            </p>

            <div className="bonus-info mt-4">
              <h5 className="mb-2">Join Today and Unlock Your Rewards</h5>
              <p className="mb-3">
                When you join TopCoin UK, you will receive 10,000 Reward TopCoin
                as part of your starter package. These rewards become available
                once you reach a total of 20,000 TopCoin through normal
                participation in the TopCoin UK programme.
              </p>
              <p className="mb-3">
                TopCoin UK Ltd is an advertising, rewards, and discount company.
                TopCoin UK Ltd is the company name and is not a cryptocurrency
                or digital coin. We are not a gambling or investment business.
              </p>
              <ul
                className="btns_group unordered_list justify-content-center mt-4 p-0"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay="100"
              >
                <li>
                  <Link className="ico_creative_btn" to="/sign_up">
                    <span className="btn_wrapper px-5 py-3">
                      <span className="btn_label">
                        Join Now & Get Your TopCoin
                      </span>
                      <span className="btn_icon_right">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          fill="currentColor"
                        >
                          <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                        </svg>
                      </span>
                    </span>
                  </Link>
                </li>
              </ul>

              <p className="mb-2 mt-5" style={{ fontWeight: 600 }}>
                How Your Bonus TopCoin Works
              </p>
              <p className="mb-2">
                Bonus TopCoin is added to your main TopCoin balance as "Bonus
                TopCoin."
              </p>
              <p className="mb-2" style={{ fontWeight: 600 }}>
                This Bonus TopCoin is an additional reward given to support your
                progress.
              </p>

              <div
                className="captain-tc-card-section mt-5"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <h5 className="mb-3" style={{ fontWeight: 600 }}>
                  Captain TC Cash-Wallet Card
                </h5>
                <img
                  loading="lazy"
                  src={captainTcCard}
                  alt="Captain TC Cash-Wallet Card"
                  style={{
                    maxWidth: "240px",
                    width: "100%",
                    borderRadius: "12px",
                    marginBottom: "20px",
                  }}
                />

                
                <p className="mb-3">
                  A special reward card from TopCoin UK that gives you access to
                  the Captain TC Cash-Wallet promotion.
                </p>
                <p className="mb-3">
                  Each series contains 5,000 cards only. Once a series is
                  completed, no more cards will be issued in that series.
                </p>
                <p className="mb-3">
                  Every TopCoin collected in your Main Wallet is matched
                  1-for-1 and added to your Cash Wallet Card balance.
                </p>

                <p className="mb-3" style={{ fontWeight: 600 }}>
                  Choose your card:
                </p>

                <div className="row justify-content-center">
                  {[
                    { amount: "£5", color: "#cd7f32" },
                    { amount: "£10", color: "#C0C0C0" },
                    { amount: "£25", color: "#FFD700" },
                  ].map((card) => (
                    <div className="col-md-4 mb-3" key={card.amount}>
                      <div
                        className="tc-card-option"
                        style={{
                          background:
                            "linear-gradient(145deg, rgba(0, 11, 94, 0.9), rgba(0, 25, 100, 0.95))",
                          border: `1px solid ${card.color}55`,
                          borderRadius: "16px",
                          padding: "30px 20px",
                          height: "100%",
                          position: "relative",
                          overflow: "hidden",
                          transition: "all 0.3s ease",
                          boxShadow: `0 4px 20px ${card.color}15`,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform =
                            "translateY(-5px)";
                          e.currentTarget.style.borderColor = `${card.color}aa`;
                          e.currentTarget.style.boxShadow = `0 8px 30px ${card.color}30`;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.borderColor = `${card.color}55`;
                          e.currentTarget.style.boxShadow = `0 4px 20px ${card.color}15`;
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "3px",
                            background: `linear-gradient(90deg, transparent, ${card.color}, transparent)`,
                          }}
                        ></div>
                        <div
                          style={{
                            fontSize: "36px",
                            fontWeight: 700,
                            color: card.color,
                            marginBottom: "6px",
                            lineHeight: 1.2,
                          }}
                        >
                          {card.amount}
                        </div>
                        <h6
                          style={{
                            fontWeight: 600,
                            color: "#CCCEEF",
                            marginBottom: "12px",
                            fontSize: "16px",
                          }}
                        >
                          Card
                        </h6>
                        <p
                          style={{
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "rgba(204, 206, 239, 0.8)",
                            marginBottom: 0,
                          }}
                        >
                          Each time you reach 250 TopCoin, you become eligible
                          to receive {card.amount}, up to 20 times, until you
                          complete the 5,000 TopCoin Captain TC Card promotion.
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
